import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { buildUsdtCashoutDraft } from '../cashout-draft-builders';
import { CashoutDraft } from '../cashout-currency.types';

@Component({
  selector: 'app-usdt-form',
  templateUrl: './usdt-form.component.html',
  styleUrl: '../../add-cashout.component.scss',
})
export class UsdtFormComponent implements OnInit {
  @Input() ctx!: any;
  @Output() draftReady = new EventEmitter<CashoutDraft>();

  readonly networkOptions = ['TRC20', 'ERC20', 'Polygon'];

  ngOnInit(): void {
    this.setCryptoDefaults();
  }

  saveTransaction(): void {
    this.setCryptoDefaults();
    const draft = buildUsdtCashoutDraft(this.ctx);
    if (draft) {
      this.draftReady.emit(draft);
    }
  }

  setNetwork(network: string): void {
    this.ctx.newTransactionForm.controls.account_type.setValue(network);
  }

  private setCryptoDefaults(): void {
    this.clearHiddenWalletValidators();
    if (!this.ctx.newTransactionForm.controls.account_type.value) {
      this.ctx.newTransactionForm.controls.account_type.setValue('TRC20');
    }
  }

  private clearHiddenWalletValidators(): void {
    this.ctx.newTransactionForm.controls.company_id.clearValidators();
    this.ctx.newTransactionForm.controls.company_name.clearValidators();
    this.ctx.newTransactionForm.controls.company_id.setValue('');
    this.ctx.newTransactionForm.controls.company_name.setValue('');
    this.ctx.newTransactionForm.controls.company_id.updateValueAndValidity({
      emitEvent: false,
    });
    this.ctx.newTransactionForm.controls.company_name.updateValueAndValidity({
      emitEvent: false,
    });
  }
}
